(function() {
    angular.module('ngmvac').controller('carPaymentController', CarPaymentController);
    CarPaymentController.$inject = ['$window', '$document', '$scope', '$filter', '$timeout', 'HotelFactory', 'ContentApiService', 'ReservationFactory', 'DatosCotizador', 'timeService'];

    function CarPaymentController($window, $document, $scope, $filter, $timeout, HotelFactory, ContentApiService, ReservationFactory, DatosCotizador, timeService) {

        var vm = this;
        vm.timeExpired = false;


        ReservationFactory.timeSinceBooking().then(function(response){
            console.log(response, "response-->");
            // timeService.init({
            //     end: function() {
            //         console.log('Tu tiempo a terminado');
            //         vm.timeExpired = true;
            //     },
            //     limit: 10
            // });

            vm.payment = response.data;

            timeService.init({
                callback: function (conteo) {
                    vm.counter = conteo;
                },
                end: function () {
                    HotelFactory.cancelOperation()
                        .then(function () {
                            console.info('exit');
                        })
                        .catch(function (err) {
                            console.error(err.data);
                        });
                    vm.timeExpired = true;
                },
                initialCounting: vm.payment
            });

        });

        var pathname = $window.location.pathname;
        var pathnameArr = pathname.split('/');
    
        vm.iconocurrency = function(currency) {
            if (currency == 'USD') {
                $scope.iconocurrency = "$";
            } else if (currency == 'EUR') {
                $scope.iconocurrency = "€";
            } else if (currency == 'GBP') {
                $scope.iconocurrency = "£";
            } else if (currency == 'MXN') {
                $scope.iconocurrency = "$";
            }
        }

    }
})();